import React from 'react'
import { map } from 'lodash'
import { Grid, makeStyles } from '@material-ui/core'
import Domino from '../atoms/Domino'
import useWindowSize from '../../hooks/useWindowSize'
import {
  HANDICAP_TYPE,
  ACCESSIBILITY_LEVEL,
} from '../../domains/cards/enums/handicaps'

const useStyles = makeStyles(() => ({
  root: ({ ratio, forceHorizontal }) => ({
    margin: 0,
    flex: 'none',
    flexWrap: ratio > 0.94 || forceHorizontal ? 'nowrap' : 'wrap',
  }),
  gridItem: {
    padding: '1vw',
  },
  firstItem: {
    paddingLeft: '0 !important',
  },
  lastItem: {
    paddingRight: '0 !important',
  },
}))

const generateTooltip = (handicap, value) => {
  const textTooltip = HANDICAP_TYPE[handicap] || ''
  const textAccessibilityLevel = ACCESSIBILITY_LEVEL[value] || ''

  return (
    <>
      {textTooltip}
      <br />
      <b>{textAccessibilityLevel}</b>
    </>
  )
}

const generateDominoAriaLabel = (handicap, value) => {
  const textAriaLabel = HANDICAP_TYPE[handicap] || ''
  const textAccessibilityLevel = ACCESSIBILITY_LEVEL[value] || ''

  return `${textAccessibilityLevel} pour une ${textAriaLabel}`
}

const generateAriaLabel = (handicaps) => {
  return (
    'Liste des handicaps : ' +
    map(handicaps, (value, handicap) => {
      const textHandicap = HANDICAP_TYPE[handicap] || ''
      const textAccessibilityLevel = ACCESSIBILITY_LEVEL[value] || ''
      return `${textHandicap} : ${textAccessibilityLevel}`
    }).join('. ')
  )
}

const HandicapIconsList = (props) => {
  const { handicaps, forceHorizontal, spacing } = props
  const { ratio } = useWindowSize()
  const classes = useStyles({ ratio, forceHorizontal })

  return (
    <Grid
      className={classes.root}
      container
      item
      xs
      spacing={spacing}
      role="list"
      tabIndex={0}
      aria-label={generateAriaLabel(handicaps)}
    >
      {map(handicaps, (value, handicap) => (
        <Grid
          className={classes.gridItem}
          key={handicap}
          item
          xs={ratio > 0.94 || forceHorizontal ? true : 3}
        >
          <Domino
            tooltip={generateTooltip(handicap, value)}
            tabIndex={-1}
            handicap={handicap}
            value={value}
            ariaLabel={generateDominoAriaLabel(handicap, value)}
            placement="left"
          />
        </Grid>
      ))}
    </Grid>
  )
}

export default HandicapIconsList
